import { DialogProps } from '../types';
import { classNames } from 'primereact/utils';

export const DialogTailwindThemes = {
  dialog: {
    root: ({ state }: DialogProps) => ({
      className: classNames(
        'rounded-lg shadow-lg border-0',
        // A column, so the content scrolls instead of pushing the footer past `max-h`.
        'flex flex-col max-h-[90%] bg-theme-white transform scale-100',
        'm-0 w-[50vw]',
        {
          'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized,
        },
      ),
    }),
    header: ({ props }: DialogProps) => ({
      className: classNames(
        'flex items-center justify-between shrink-0',
        'py-6 pr-6 pl-15 select-none cursor-move border-t-0 text-black bg-white',
        props.headerClassName,
      ),
    }),
    headerTitle: 'mt-6 text-lg font-semibold',
    headerIcons: ({ props }: DialogProps) => ({
      className: classNames('flex self-start', props?.headerIconsClassName),
    }),
    closeButton: {
      className: classNames(
        'flex items-center justify-center overflow-hidden relative cursor-pointer',
        'size-8 text-black border-0 bg-transparent rounded-full transition duration-200 ease-in-out mr-2 last:mr-0',
        'hover:border-transparent hover:bg-fletchers-green-50',
        'outline-transparent focus-visible:outline-2 focus-visible:outline-fletchers-green-500',
      ),
    },
    closeButtonIcon: 'size-4 inline-block',
    content: ({ state, props }: DialogProps) => ({
      className: classNames('overflow-y-auto', 'px-15 pt-0 pb-8 text-black bg-white', props.contentClassName, {
        grow: state.maximized,
      }),
    }),
    footer: {
      className: ({ props }: DialogProps) =>
        classNames('shrink-0', 'px-15 pt-0 pb-8 border-t-0 text-black text-right bg-white', props.footerClassName),
    },
    mask: ({ state }: DialogProps) => ({
      className: classNames('z-20 transition duration-200', { 'bg-black/50': state.containerVisible }),
    }),
    transition: ({ props }: DialogProps) => {
      return props.position === 'top'
        ? {
            enterFromClass: 'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0',
            enterActiveClass: 'transition-all duration-200 ease-out',
            leaveActiveClass: 'transition-all duration-200 ease-out',
            leaveToClass: 'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0',
          }
        : props.position === 'bottom'
          ? {
              enterFromClass: 'opacity-0 scale-75 translate-y-full',
              enterActiveClass: 'transition-all duration-200 ease-out',
              leaveActiveClass: 'transition-all duration-200 ease-out',
              leaveToClass: 'opacity-0 scale-75 translate-x-0 translate-y-full translate-z-0',
            }
          : props.position === 'left' || props.position === 'top-left' || props.position === 'bottom-left'
            ? {
                enterFromClass: 'opacity-0 scale-75 -translate-x-full translate-y-0 translate-z-0',
                enterActiveClass: 'transition-all duration-200 ease-out',
                leaveActiveClass: 'transition-all duration-200 ease-out',
                leaveToClass: 'opacity-0 scale-75  -translate-x-full translate-y-0 translate-z-0',
              }
            : props.position === 'right' || props.position === 'top-right' || props.position === 'bottom-right'
              ? {
                  enterFromClass: 'opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0',
                  enterActiveClass: 'transition-all duration-200 ease-out',
                  leaveActiveClass: 'transition-all duration-200 ease-out',
                  leaveToClass: 'opacity-0 scale-75 opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0',
                }
              : {
                  enterFromClass: 'opacity-0 scale-75',
                  enterActiveClass: 'transition-all duration-200 ease-out',
                  leaveActiveClass: 'transition-all duration-200 ease-out',
                  leaveToClass: 'opacity-0 scale-75',
                };
    },
  },
};
